import React from "react";
import SriLanka from "./srilanka";
import "./chart-4.css";

export default function Highlights() {
  return (
    <div>
      <div>
        <h2 className="main-topic-chart-4-p career-chart-08">
          Breakdown of OSH Training by Country
        </h2>

        <div className="empower-chart-4-paragraph-two-column"></div>

        <div>{<SriLanka />}</div>
      </div>
    </div>
  );
}
